// TooltipLeft.jsx

import React, { useState, useRef, useEffect } from 'react';
import styles from './TooltipLeft.module.css';

const TooltipLeft = ({ text, children, link, backgroundColor }) => {
  const [hovered, setHovered] = useState(false);
  const [tooltipStyle, setTooltipStyle] = useState({});
  const [arrowStyle, setArrowStyle] = useState({});
  const tooltipRef = useRef(null);

  const showTooltip = () => setHovered(true);
  const hideTooltip = () => setHovered(false);

  useEffect(() => {
    if (!hovered || !tooltipRef.current) {
      setTooltipStyle({});
      setArrowStyle({});
      return;
    }

    const tooltipRect = tooltipRef.current.getBoundingClientRect();
    const { innerWidth, innerHeight } = window;
    const offset = 8; // 触发元素与 Tooltip 间隔

    // 1) 默认：Tooltip 在触发元素左侧，垂直居中
    //    假设触发元素在 (0, 0) 左上，Tooltip 向左偏移 offset
    let newStyle = {
      top: '50%',                         // 垂直居中
      right: `calc(100% + ${offset}px)`, // 贴在左侧：用 right 替代 left
      transform: 'translateY(-50%)',
    };

    // 箭头默认在 Tooltip 内的右边缘，垂直居中
    let newArrowStyle = {
      top: '50%',
      right: 0,
      transform: 'translate(100%, -50%)',
    };

    // 2) 判断是否超出屏幕左边界（因为 Tooltip 在左侧，我们要看 tooltipRect.left）
    //    但要先“把它渲染”到页面上，再测量 tooltipRect
    //    这里先简单判断：如果 tooltipRect.left < offset，就往右移
    //    tooltipRect.left 是“绝对坐标”，需要先把 tooltip 放进去才知道
    if (tooltipRect.left < offset) {
      const pushX = offset - tooltipRect.left;
      // 向右移 pushX
      // transform 原本是 translateY(-50%)，加上 translateX
      newStyle.transform = `translateY(-50%) translateX(${pushX}px)`;
      // 箭头反向加上 translateX(-pushX)
      newArrowStyle.transform = `translate(100%, -50%) translateX(-${pushX}px)`;
    }

    // 3) 判断是否超出屏幕顶部或底部
    //    如果上方超出
    if (tooltipRect.top < offset) {
      const pushY = offset - tooltipRect.top;
      newStyle.transform += ` translateY(${pushY}px)`;
      newArrowStyle.transform += ` translateY(-${pushY}px)`;
    }
    //    如果下方超出
    else if (tooltipRect.bottom > innerHeight - offset) {
      const pushY = tooltipRect.bottom - (innerHeight - offset);
      newStyle.transform += ` translateY(-${pushY}px)`;
      newArrowStyle.transform += ` translateY(${pushY}px)`;
    }

    setTooltipStyle(newStyle);
    setArrowStyle(newArrowStyle);
  }, [hovered]);

  return (
    <div
      className={styles.tooltipWrapper}
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
    >
      {children}

      {hovered && (
        <div
          className={styles.tooltip}
          ref={tooltipRef}
          style={{
            ...tooltipStyle,
            '--tooltip-bg': backgroundColor
          }}
        >
          {text}

          {link && (
            <a
              href={link}
              target="_blank"
              rel="noreferrer"
              className={styles.learnMoreLink}
            >
              Learn More
            </a>
          )}

          <div
            className={styles.arrow}
            style={arrowStyle}
          />
        </div>
      )}
    </div>
  );
};

export default TooltipLeft;